import {MdbsCore} from "@/api/tsclient";
import ReadonlyDataField from "@/models/ReadonlyDataField";
import IEventReportFieldDto = MdbsCore.IEventReportFieldDto;
import IDataFieldDto = MdbsCore.IDataFieldDto;

export default class ReadonlyDataFields {
    private readonly _dataFields = new Array<ReadonlyDataField>();
    private _dataFieldsTree = new Array<ReadonlyDataField>();

    private constructor(dataFields: Array<ReadonlyDataField>) {
        this._dataFields = dataFields;

        this.buildReadonlyDataFieldsTree();
    }

    public static fromEventReportFields(eventReportFields: Array<IEventReportFieldDto>) {
        // console.dir(eventReportFields)
        const fields = eventReportFields.map(rf => new ReadonlyDataField( {
            id: rf.id!,
            values: rf.values,
            order: rf.order,
            definition: rf.definition,
            definitionType: rf.definitionType,
            displayKey: rf.displayKey,
            displayName: rf.displayName,
            identifier: rf.identifier ?? "",
            parentFieldId: rf.parentFieldId,
            referenceId: rf.referenceId ?? "",
            referenceType: rf.referenceType ?? "",
            tags: rf.tags
        }));

        return new ReadonlyDataFields(fields);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public static fromDataFieldDtos(dataFieldDtos: Array<IDataFieldDto>) {
        // implement mapping if needed
    }

    public static empty() {
        return new ReadonlyDataFields([]);
    }

    public get allFields() {
        return this._dataFields;
    }

    public get tree() {
        return this._dataFieldsTree;
    }

    public get dataFieldsFromField() {
        return (fieldId: string) => this._dataFields.find(df => df.id == fieldId);
    }

    private buildReadonlyDataFieldsTree() {
        this._dataFieldsTree.clear();

        this._dataFieldsTree.push(...this._dataFields.filter(f => !f.parentId));

        for (let field of this._dataFields.filter(f => f.parentId)) {
            const parentField = this._dataFields.find(f => f.id == field.parentId);
            if (!parentField) continue;

            parentField.addChild(field);
        }

        this._dataFieldsTree.sort((a, b) => (a.order > b.order) ? 1 : -1)
    }
}